"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseScriptLoader = void 0;
const helpers_1 = require("../../../core/helpers");
class BaseScriptLoader {
    scriptLoaded(url, onLoad) {
        helpers_1.Log.info(`ScriptLoader - Loaded script url ${url}`);
        onLoad(url);
    }
    scriptError(url, onError) {
        helpers_1.Log.info(`ScriptLoader - Error loading script url ${url}`);
        onError(url);
    }
}
exports.BaseScriptLoader = BaseScriptLoader;
//# sourceMappingURL=index.js.map